import { METHOD } from './method'

export const API_VOUCHER = {
    LIST: {
        api: '/v1/dashboard-admin/voucher/list',
        method: METHOD.POST,
    },
    EXPORT: {
        api: '/v1/dashboard-admin/voucher/list/export',
        method: METHOD.POST,
    },
    BULK_ACTION: {
        api: '/v1/dashboard-admin/voucher/bulk-action',
        method: METHOD.POST,
    },
    GIFT_LIST: {
        api: '/v1/dashboard-admin/voucher/gift',
        method: METHOD.GET,
    },
    PRODUCT_LIST: {
        api: '/v1/dashboard-admin/voucher/product',
        method: METHOD.GET,
    },
    CATEGORY_LIST: {
        api: '/v1/dashboard-admin/voucher/category',
        method: METHOD.GET,
    },
    BRAND_LIST: {
        api: '/v1/dashboard-admin/voucher/brand',
        method: METHOD.GET,
    },
    SHIPPING_METHODS: {
        api: '/v1/master/shipping-methods',
        method: METHOD.GET,
    },
    PAYMENT_METHODS: {
        api: '/v1/master/payment-methods',
        method: METHOD.GET,
    },
    ALLOWED_EMAIL: {
        api: '/v1/dashboard-admin/voucher/user',
        method: METHOD.GET,
    },
    DETAIL: {
        api: '/v1/dashboard-admin/voucher',
        method: METHOD.GET,
    },
    URL_THUMBNAIL: {
        api: '/v1/dashboard-admin/voucher/storage-url/attachment',
        method: METHOD.POST,
    },
    CREATE: {
        api: '/v1/dashboard-admin/voucher',
        method: METHOD.POST,
    },
    UPDATE: {
        api: '/v1/dashboard-admin/voucher',
        method: METHOD.PUT,
    },
    DRAFT: {
        api: '/v1/dashboard-admin/voucher/draft',
        method: METHOD.PUT,
    },
    LIST_CODE: {
        api: '/v1/dashboard-admin/voucher/codes',
        method: METHOD.GET,
    },
    DUPLICATE_VOUCHER: {
        api: '/v1/dashboard-admin/voucher/duplicate',
        method: METHOD.POST,
    },
}
